module.exports = __webpack_public_path__ + "img/OverseaMember11.4e61b3df.jpg";